import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../Hooks/useStore";

export type LoginSliceInitialStateTypes = {
  isLogin: boolean;
};

const initialState = {
  isLogin: false,
} as LoginSliceInitialStateTypes;

export const checkLoginSlice = createSlice({
  name: "loginSlice",
  reducers: {
    setIsLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
  },
  initialState,
});

export const { setIsLogin } = checkLoginSlice.actions;

export const useLogin = () => {
  return useAppSelector((state) => state.login);
};
export default checkLoginSlice.reducer;
